@if (doctor && formGroup) {
  <div class="container">
    <div class="section-container">
      <div class="section left">
        <div class="content">
          <h1 class="title">{{ 'documentation_title' | locale }}</h1>
        </div>
      </div>
      <div class="section center">
        <div class="content">
          <div class="white-container">
            <h1 class="title">{{ doctor.name }}</h1>
            <h2 class="title-accent">{{ 'documentation_card_subtitle' | locale }}</h2>
            <p class="card-content">{{ 'documentation_card_content' | locale }} <b>altamedico&#64;llamandoaldoctor.com</b></p>
          </div>
          @if (documentation.includes(Documentation.ENROLLMENT)) {
            <app-enrollment
              [formGroup]="enrollment">
            </app-enrollment>
          }
          @for (control of fileData.value; track control; let i = $index) {
            <h2 class="title-accent" style="margin: 2rem 0 1rem;">{{ control.text | locale }}</h2>
            <form [formGroup]="control.fileDataFormGroup">
              @if (hasProperty(control.fileDataFormGroup.controls, 'name')) {
                <mat-label>{{ 'documentation_file_data_name' | locale }}</mat-label>
                <mat-form-field>
                  <input
                    matInput
                    formControlName="name"
                    [placeholder]="'documentation_file_data_name_placeholder' | locale"
                    />
                  <mat-error>{{ control.fileDataFormGroup.get('name') | errorMessage }}</mat-error>
                </mat-form-field>
              }
              <app-datepicker
                label="documentation_enrollment_date"
                [form]="formGroup"
                controlName="expirationDate"
                placeholder="documentation_enrollment_date_placeholder">
              </app-datepicker>
              <app-file-input
                [files]="control.fileDataFormGroup.value.fileName ? [ control.fileDataFormGroup.value ] : []"
                [supportedExtensions]="supportedFileExtensions"
                (uploadFileEvent)="onUploadFile($event, control.fileDataFormGroup)"
                (removeFileEvent)="onRemoveFile(control.fileDataFormGroup)">
              </app-file-input>
            </form>
          }
          <button
            type="submit"
            mat-flat-button
            color="primary"
            (click)="submit()">
            {{ 'default_send' | locale }}
            <mat-icon svgIcon="arrow-right" class="east"></mat-icon>
          </button>
        </div>
      </div>
      <div class="section right"></div>
    </div>
  </div>
}
